( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .service("InvoiceDialogProvider", InvoiceDialogProvider);

    InvoiceDialogProvider.$inject = ['$timeout'];

    function InvoiceDialogProvider($timeout) {
        return {
            composeInvoicePrices: composeInvoicePrices,
            calculateTotalWeight: calculateTotalWeight,
            calculateTotalWeightLb: calculateTotalWeightLb,
            calculateCommissionValue: calculateCommissionValue,
            calculateTotalWeightLbDetails: calculateTotalWeightLbDetails,
            calculateTotalValue: calculateTotalValue,
            calculateTotalOverrideValue: calculateTotalOverrideValue,
            calculateTotalQty: calculateTotalQty,
            calculateTotalMt: calculateTotalMt,
            addInvoicePrice: addInvoicePrice,
            applyAggregatedFields: applyAggregatedFields,
            initInvoicePrices: initInvoicePrices,
            calculateAvgPrice: calculateAvgPrice,
            calculateAvgNContractPrice: calculateAvgNContractPrice,
            calculateTotalNContractValue: calculateTotalNContractValue,
            onPriceChanged: onPriceChanged,
            onNContractPriceChanged: onNContractPriceChanged,
            updateValuesWithNewUnitType: updateValuesWithNewUnitType,
            initInvoicePricesOnDetails: initInvoicePricesOnDetails,
            processWeightOnDetails: processWeightOnDetails,
            calculateTotalWeightOnDetails: calculateTotalWeightOnDetails,
            getPriceTypeDivider: getPriceTypeDivider,
            getWeight: getWeight,
            calculateTotalOverrideValueDisplay: calculateTotalOverrideValueDisplay,
            calculateTotalWeightDisplay: calculateTotalWeightDisplay,
            onCommissionValueChanged: onCommissionValueChanged,
            checkLotExist: checkLotExist
        };

        function checkLotExist(list, id) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].lot.id === id) {
                    return true;
                }
            }
            return false;
        }

        function composeInvoicePrices(vm) {
            var editMode = vm.invoice && vm.invoice !== null && vm.invoice.id && vm.invoice.id > 0 && vm.invoice.shipment && vm.invoice.shipment.id && vm.invoice.shipment.id > 0;
            vm.allLots = angular.copy(vm.contractLots);
            if (editMode && vm.firstLoading && vm.allLots.length === vm.invoicePrices.length) {
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    vm.invoicePrices[i].index = i + 1;
                }
            } else {
                for (var ii = 0; ii < vm.allLots.length; ii++) {
                    if (!checkLotExist(vm.invoicePrices, vm.allLots[ii].id)) {
                        var ip = composeInvoicePriceObject(vm, vm.allLots[ii], ii + 1);
                        vm.invoicePrices.push(ip);
                    }
                 }
            }

            if (vm.invoice && vm.invoice.editedTotalValue && vm.invoice.editedTotalValue > 0) {
                vm.editedTotalValue = vm.invoice.editedTotalValue;
            } else {
                vm.editedTotalValue = calculateTotalOverrideValue(vm);
            }
            if(vm.invoice && vm.invoice.editedTotalValueEur && vm.invoice.editedTotalValueEur > 0) {
               vm.editedTotalValueEur = vm.invoice.editedTotalValueEur;
            } else {
                vm.editedTotalValueEur = calculateTotalOverrideValue(vm);
            }
        }

        function composeInvoicePriceObject(vm, lot, index) {
            var ip = {
                index: index,
                lot: lot,
                shipment: undefined,
                quantity: (lot && lot !== null) ? lot.qtyBales : undefined,
                weight: 0,
                price: 0,
                ncontractPrice: 0,
                wtUnitType: (vm.invoice.selectedContract && vm.invoice.selectedContract !== null)
                    ? vm.invoice.selectedContract.unitType : 'KG',
                priceValue: 0,
                editedPriceValue: 0,
                ncontractPriceValue: 0,
                weightError: false,
                contractUnitType: (vm.invoice.selectedContract && vm.invoice.selectedContract !== null)
                    ? vm.invoice.selectedContract.unitType : 'KG'
            };
            if (lot && lot !== null) {
                processWeight(vm, lot, ip);
            }
            if (vm.invoice.selectedContract && vm.invoice.selectedContract.priceModel === 'FIXED') {
                ip.price = vm.invoice.selectedContract.fixedPrice;
            }

            $timeout(function() {
                ip.priceValue = getWeight(vm, ip) * ip.price / getPriceTypeDivider(vm);
                ip.ncontractPriceValue = getWeight(vm, ip) * ip.ncontractPrice / getPriceTypeDivider(vm);
                ip.editedPriceValue = angular.copy(ip.priceValue);
                vm.editedTotalValue = calculateTotalOverrideValue(vm);
                vm.totalNContractValue = calculateTotalNContractValue(vm);
            }, 100);
            return ip;
        }

        function processWeight(vm, lot, ip) {
            switch(vm.invoice.selectedContract.unitType) {
                case 'LB':
                    ip.weight = lot.purchLandedNetLbs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = ip.weight;
                    ip.weightInKgs = lot.purchLandedNetKgs;
                    ip.weightInMts = lot.purchLandedNetMTs;
                    break;
                case 'KG':
                    ip.weight = lot.purchLandedNetKgs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = lot.purchLandedNetLbs;
                    ip.weightInKgs = ip.weight;
                    ip.weightInMts = lot.purchLandedNetMTs;
                    break;
                case 'MT':
                    ip.weight = lot.purchLandedNetMTs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = lot.purchLandedNetLbs;
                    ip.weightInKgs = lot.purchLandedNetKgs;
                    ip.weightInMts = ip.weight;
                    break;
                default:
                    break;
            }
        }

        function updateLotWeight(ip, lot) {
            if (ip.weight === null || ip.weight === 0) {
                if (lot.actualWtAvg !== null && lot.actualWtAvg > 0) {
                    ip.weight = lot.actualWtAvg;
                } else {
                    ip.weight = 0;
                    ip.weightError = true;
                }
            }
        }

        function addInvoicePrice(vm) {
            if (!vm.invoicePrices || vm.invoicePrices === null) {
                vm.invoicePrices = [];
            }
            var ip = composeInvoicePriceObject(vm, undefined, vm.invoicePrices.length + 1);
            vm.invoicePrices.push(ip);
        }

        function calculateTotalWeight(vm) {
            var unitType = vm.invoice.selectedContract.unitType;
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        var ip = vm.invoicePrices[i];
                        switch (unitType) {
                            case "KG":
                                total += ip.weightInKgs;
                                break;
                            case "MT":
                                total += ip.weightInMts;
                                break;
                            case "LB":
                                total += ip.weightInLbs;
                                break;
                        }
                    }
                }
                return vm.setPrecision(total, vm.invoice.weightPrecision);
            }
            return 0;
        }

        function calculateTotalWeightOnDetails(vm) {
            var unitType = vm.invoice.invoiceContractUnitType;
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i] && vm.invoicePrices[i].weight > 0) {
                        var ip = vm.invoicePrices[i];
                        switch (unitType) {
                            case "KG":
                                total += ip.weightInKgs;
                                break;
                            case "MT":
                                total += ip.weightInMts;
                                break;
                            case "LB":
                                total += ip.weightInLbs;
                                break;
                        }
                    }
                }
                return total;
            }
            return 0;
        }

        function calculateTotalWeightLb(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        switch (vm.invoice.invWtUnits) {
                            case "LB":
                                total += vm.invoicePrices[i].weightInLbs * 1.0;
                                break;
                            case "KG":
                                total += vm.invoicePrices[i].weightInKgs * 1.0;
                                break;
                            case "MT":
                                total += vm.invoicePrices[i].weightInMts * 1.0;
                                break;
                            default:
                                break;
                        }
                    }
                }
                return vm.setPrecision(total, vm.invoice.weightPrecision);
            } else {
                return vm.setPrecision(0, vm.invoice.weightPrecision);
            }
        }

        function calculateCommissionValue(vm) {
            var weight = calculateTotalWeightLb(vm);
            var commissionRate = isNaN(vm.invoice.commissionRate) ? 0 : vm.invoice.commissionRate;
            return weight * commissionRate;
        }

        function calculateTotalWeightLbDetails(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        switch (vm.invoice.invoiceWtUnits) {
                            case "LB":
                                total += vm.setPrecision(vm.invoicePrices[i].weightInLbs, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            case "KG":
                                total += vm.setPrecision(vm.invoicePrices[i].weightInKgs, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            case "MT":
                                total += vm.setPrecision(vm.invoicePrices[i].weightInMts, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            default:
                                break;
                        }
                    }
                }
                return vm.setPrecision(total, vm.invoice.invoiceWeightPrecision);
            }
            return vm.setPrecision(0, vm.invoice.invoiceWeightPrecision);
        }

        function calculateTotalValue(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += (vm.invoicePrices[i].weightInLbs * vm.invoicePrices[i].price) * 1.0;
                    }
                }
                return total;
            }
            return 0;
        }

        function calculateTotalOverrideValue(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.invoicePrices[i].editedPriceValue * 1.0;
                    }
                }
                return vm.setPrecision(total, vm.invoice.valuePrecision );
            }
            return vm.setPrecision(0, vm.invoice.valuePrecision);
        }

        function calculateTotalOverrideValueDisplay(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.setPrecision(vm.invoicePrices[i].editedPriceValue, vm.invoice.valuePrecision) * 1.0;
                    }
                }
                return vm.setPrecision(total, vm.invoice.valuePrecision);
            }
            return vm.setPrecision(0, vm.invoice.valuePrecision);
        }

        function calculateTotalQty(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.invoicePrices[i].quantity * 1.0;
                    }
                }
                return total;
            }
            return 0;
        }

        function calculateTotalMt(vm) {
            if(vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for(var i = 0; i < vm.invoicePrices.length; i++) {
                    if(vm.invoicePrices[i]) {
                        total += vm.invoicePrices[i].weightInMts;
                    }
                }
                return vm.setPrecision(total, vm.invoice.weightPrecision);
            }
            return vm.setPrecision(0, vm.invoice.weightPrecision);
        }

        function calculateAvgPrice(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.invoicePrices[i].price * 1.0;
                    }
                }
                return vm.setPrecision(total / vm.invoicePrices.length, vm.invoice.pricePrecision);
            }
            return vm.setPrecision(0, vm.invoice.pricePrecision);
        }

        function calculateAvgNContractPrice(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.setPrecision(vm.invoicePrices[i].ncontractPrice, vm.invoice.pricePrecision) * 1.0;
                    }
                }
                return vm.setPrecision(total / vm.invoicePrices.length, vm.invoice.pricePrecision);
            }
            return vm.setPrecision(0, vm.invoice.pricePrecision);
        }

        function calculateTotalNContractValue(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        total += vm.setPrecision(vm.invoicePrices[i].ncontractPriceValue, vm.invoice.valuePrecision) * 1.0;
                    }
                }
                return vm.setPrecision(total, vm.invoice.valuePrecision);
            }
            return vm.setPrecision(0, vm.invoice.valuePrecision);
        }

        function calculateTotalWeightDisplay(vm) {
            if (vm.invoicePrices && vm.invoicePrices !== null && vm.invoicePrices.length > 0) {
                var total = 0;
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    if (vm.invoicePrices[i]) {
                        switch (vm.invoicePrices[i].contractUnitType) {
                            case 'LB':
                                total += vm.setPrecision(vm.invoicePrices[i].weightInLbs, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            case 'KG':
                                total += vm.setPrecision(vm.invoicePrices[i].weightInKgs, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            case 'MT':
                                total += vm.setPrecision(vm.invoicePrices[i].weightInMts, vm.invoice.invoiceWeightPrecision) * 1.0;
                                break;
                            default:
                                break;
                        }
                    }
                }
                return vm.setPrecision(total, vm.invoice.invoiceWeightPrecision);
            }
            return vm.setPrecision(0, vm.invoice.invoiceWeightPrecision);
        }

        function applyAggregatedFields(vm) {
            vm.invoice.avgPrice = calculateAvgPrice(vm);
            vm.invoice.totalValue = calculateTotalValue(vm);
            if( vm.invoice.currency !== "EUR" ) {
                vm.invoice.editedTotalValue = vm.editedTotalValue;
            } else {
                vm.invoice.editedTotalValueEur = vm.editedTotalValueEur;
            }
            vm.invoice.ncontractValue = calculateTotalNContractValue(vm);
            vm.invoice.avgNPrice = calculateAvgNContractPrice(vm);
            vm.invoice.qtyBales = calculateTotalQty(vm);
            var totalWeight = calculateTotalWeight(vm);

            switch (vm.invoice.selectedContract.unitType) {
                case 'LB':
                    vm.invoice.landedNetLbs = totalWeight;
                    break;
                case 'KG':
                    vm.invoice.landedNetKgs = totalWeight;
                    break;
                case 'MT':
                    vm.invoice.landedNetMTs = totalWeight;
                    break;
                default:
                    break;
            }
        }

        function initInvoicePrices(vm) {
            if (vm.invoicePrices) {
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    var ip = vm.invoicePrices[i];
                    var ipLot = angular.copy(ip.lot);
                    vm.invoicePrices[i].fixation = (vm.invoicePrices[i].fixation && vm.invoicePrices[i].fixation !== null) ? vm.invoicePrices[i].fixation.id : undefined;
                    if (ip.lot && ip.lot !== null) {
                        processWeight(vm, ipLot, ip);
                    }
                    vm.invoicePrices[i].index = i + 1;
                }
            }
        }

        function initInvoicePricesOnDetails(vm) {
            if (vm.invoicePrices) {
                for (var i = 0; i < vm.invoicePrices.length; i++) {
                    var ip = vm.invoicePrices[i];
                    var ipLot = angular.copy(ip.lot);
                    if (ip.fixation) {
                        var varPrice;
                        if( ip.invoice.selectedContract.contractType === "SALE" && (ip.invoice.selectedContract.category === "TUI" || ip.invoice.selectedContract.category==="JAPAN") && ( ip.invoice.selectedContract.subCategory === "OUTSIDE" || ip.invoice.selectedContract.subCategory === "JAPAN" ) ) {
                            varPrice = ip.fixation.pricing.price;
                        } else {
                            varPrice = ip.fixation.pricing.icPrice;
                        }
                        ip.fixationLabel = 'Price ' + ip.fixation.pricing.label + '-' + ip.fixation.label + ': ' + varPrice + ' with Future Price: ' + ip.fixation.futurePrice
                            + (ip.fixation.pricing ? (' from ' + ip.fixation.pricing.month + ', ' + ip.fixation.pricing.year + ' of Pricing') : '');
                    } else {
                        ip.fixationLabel = 'Fixation not found';
                    }
                    if (ip.lot && ip.lot !== null) {
                        processWeightOnDetails(vm, ipLot, ip);
                    }
                    vm.invoicePrices[i].index = i + 1;
                }
            }
        }

        function processWeightOnDetails(vm, lot, ip) {
            switch (vm.invoice.invoiceContractUnitType) {
                case 'LB':
                    ip.weight = lot.purchLandedNetLbs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = ip.weight;
                    ip.weightInKgs = lot.purchLandedNetKgs;
                    ip.weightInMts = lot.purchLandedNetMTs;
                    break;
                case 'KG':
                    ip.weight = lot.purchLandedNetKgs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = lot.purchLandedNetLbs;
                    ip.weightInKgs = ip.weight;
                    ip.weightInMts = lot.purchLandedNetMTs;
                    break;
                case 'MT':
                    ip.weight = lot.purchLandedNetMTs;
                    updateLotWeight(ip, lot);
                    ip.weightInLbs = lot.purchLandedNetLbs;
                    ip.weightInKgs = lot.purchLandedNetKgs;
                    ip.weightInMts = ip.weight;
                    break;
                default:
                    break;
            }
        }

        function onPriceChanged(vm, ip) {
            if (ip.priceDisplay && ip.priceDisplay !== ip.price) {
                ip.price = ip.priceDisplay;
            }
            ip.priceValue = getWeight(vm, ip) * ip.price / getPriceTypeDivider(vm);
            ip.editedPriceValue = angular.copy(ip.priceValue);
            ip.editedPriceValueDisplay = angular.copy(ip.editedPriceValue);
            $timeout(function() {
                if( vm.invoice.currency !== "EUR" ) {
                    vm.editedTotalValue = calculateTotalOverrideValue(vm);
                } else {
                    vm.editedTotalValueEur = calculateTotalOverrideValue(vm);
                }
            }, 100);
        }

        function onCommissionValueChanged(vm) {
            if (vm.invoice.commissionValueDisplay && vm.invoice.commissionValueDisplay !== vm.invoice.commissionValue) {
                vm.invoice.commissionValue = vm.invoice.commissionValueDisplay;
            }
        }

        function onNContractPriceChanged(vm, ip) {
            if (ip.ncontractPriceDisplay && ip.ncontractPriceDisplay !== ip.ncontractPrice) {
                ip.ncontractPrice = ip.ncontractPriceDisplay;
            }
            ip.ncontractPriceValue = getWeight(vm, ip) * ip.ncontractPrice / getPriceTypeDivider(vm);
            ip.ncontractPriceValueDisplay = angular.copy(ip.ncontractPriceValue);
            $timeout(function() {
                vm.totalNContractValue = calculateTotalNContractValue(vm);
            }, 100);
        }

        function getWeight(vm, ip) {
            switch (vm.invoice.invWtUnits) {
                case "LB": return vm.setPrecision(ip.weightInLbs, vm.invoice.weightPrecision);
                case "KG": return vm.setPrecision(ip.weightInKgs, vm.invoice.weightPrecision);
                case "MT": return vm.setPrecision(ip.weightInMts, vm.invoice.weightPrecision);
            }
            return 1.0;
        }

        function getPriceTypeDivider(vm) {
            if( vm.invoice.selectedContract.priceType === 'CPTS' ) {
                return 1000;
            } else if( vm.invoice.selectedContract.priceType === 'CTS' ) {
                return 100;
            } else {
                return 1;
            }
        }

        function updateValuesWithNewUnitType(vm) {
            for (var i = 0; i < vm.invoicePrices.length; i++) {
                var ip = vm.invoicePrices[i];
                ip.priceValue = getWeight(vm, ip) * ip.price / getPriceTypeDivider(vm);
                ip.editedPriceValue = angular.copy(ip.priceValue);
            }
            if( vm.invoice.currency !== "EUR" ) {
                vm.editedTotalValue = calculateTotalOverrideValue(vm);
            } else {
                vm.editedTotalValueEur = calculateTotalOverrideValue(vm);
            }
            vm.totalNContractValue = calculateTotalNContractValue(vm);
        }
    }
})();
